export default "__VITE_ASSET__DktIyccJ__"